// 引入数据配置文件
import FormConfig from "../formConfig.js";
import { fun_PostAction } from "@/api/index";
import AuditHistoryRecord from "../../../components/auditHistoryRecord/index.vue";
import TenderPictureinfor from "../../../components/tenderPictureinfor/index.vue";
import RecordDirectlyLogs from "../../contractRecordDirectly/recordDirectlyLogs/index.vue";
import { Loading } from "element-ui";

export default {
  data() {
    return {
      // 流程状态
      stepsActive: 0,
      // 流程数据
      stepsList: [
        {
          name: "发包人及项目信息",
          isSave: false,
          isActive: true,
          formList: FormConfig.projectInformation()
        },
        {
          name: "施工单位信息",
          isSave: false,
          isActive: true,
          formList: FormConfig.constructionUnitrmation()
        },
        {
          name: "监理单位信息",
          isSave: false,
          isActive: true,
          formList: FormConfig.superUnitrmation()
        },
        {
          name: "其他单位信息",
          isSave: false,
          isActive: true,
          formList: FormConfig.constructionOtherUnitmation()
        },
        {
          name: "其他信息",
          isSave: false,
          isActive: true,
          formList: FormConfig.otherInformation()
        }
      ],
      // 表单配置
      formConfigList: FormConfig.projectInformation(),
      // 表单绑定值
      form: {
        id: null, // 主键
        contractRecordDirectlyId: null, // 直接发包备案主键
        regulators: null, // 区管代码
        constructionNo: null, // 报建编号
        prjName: null, // 工程名称
        buildCorp: null, // 建设单位
        corpLegal: null, // 法定代表
        linkMan: null, // 联系人
        linkTel: null, // 联系人电话
        noteNumber: null, // 立项批准文号
        projectSite: null, // 工程地点
        fundsCharacter: null, // 资金性质
        fundsSources: null, // 资金来源及落实情况
        economicType: null, // 公司经济类型
        recordUnitName: null, // 项目核准或备案单位名称
        approvalName: null, // 批文名称
        buildingLandObtained: null, // 建设用地取得方式
        constructionArea: null, // 房屋建筑工程建筑面积
        structuralHierarchy: null, // 结构层次
        municipalProjectScale: null, // 市政工程规模
        otherProjectScale: null, // 其它工程规模
        constructionUnit: null, // 施工单位
        qualificationCategories: null, // 企业资质类别及等级
        projectManager: null, // 项目经理
        qualificationCategoryLevel: null, // 执业资格类别等级及编号
        managerCertificateNumber: null, // 项目经理安全生产考核合格证书编号
        managementCertificateNumber: null, // 专职安全生产管理人员安全生产考核合格证书编号
        planTimeLimit: null, // 计划工期
        projectCost: null, // 工程造价
        contractScope: null, // 发包范围
        state: null, // 状态
        lockNo: null, // CA锁编号
        digitalSignature: null, // 数字签名
        timeStamp: null, // 时间戳
        inputPerson: null, // 录入人员
        inputMode: null, // 录入方式
        insertDate: null, // 插入日期
        updateDate: null, // 更新日期
        situation: null, // 资金来源落实情况
        remarks: null, // 备注
        constructionUnitName: null, // 施工单位名称
        managementCertificateName: null, // 专职安全生产管理人员
        contractorLockNo: null, // 施工方CA锁编号
        contractorDigitalSignature: null, // 施工方数字签名
        contractorTimeStamp: null, // 施工方时间戳
        sealDate: null, // 盖章日期
        tenderClassNum: null, // 招标类别
        tenderContentNum: null, // 招标内容
        processState: null, // 流程状态
        projectManagerId: null, // 项目经理解锁变更记录表主键
        updateFlag: null, // 修改标志（修改发包人或施工方）
        recordState: null, // 备案状态(0正常，1解除合同，2申请解除中)
        isAuditOk: null, // 审核通过的标志
        actualAuditTime: null, // 实际审核推送时间
        auditFinalTime: null, // 审核最终时间
        projectLeaderNumber: null, // 审核最终时间
        regulatorsName: null, // 区管代码名称
        projectManagerName: null, // 项目经理名称
        publishState: null, // 公示状态
        expectAuditTime: null, // 预计审核推送时间
        totalInvestment: null, // 批准投资总额（万元）
        projectManagerIdCard: null, // 项目经理身份证号码
        projectLeaderName: null, // 公示项目负责人名称
        isAgree: null, // 是否同意
        isUnion: null, // 是否允许联合体
        econUnit: null, // 勘察单位
        econUnitName: null, // 勘察单位名称
        econProjectManager: null, // 勘察项目负责人
        econProjectManagerName: null, // 勘察项目经理名称
        econProjectManagerIdCard: null, // 勘察项目经理身份证号码
        designUnit: null, // 设计单位
        designUnitName: null, // 设计单位名称
        designProjectManager: null, // 设计项目负责人
        designProjectManagerName: null, // 设计项目经理名称
        designProjectManagerIdCard: null, // 设计项目经理身份证号码
        superUnit: null, // 监理单位
        superUnitName: null, // 监理单位名称
        superProjectManager: null, // 监理项目负责人
        superProjectManagerName: null, // 监理项目经理名称
        superProjectManagerIdCard: null, // 监理项目经理身份证号码
        superQualificationCategories: null, // 监理企业资质类别及等级
        superQualificationCategoryLevel: null, // 监理执业资格类别等级及编号
        superManagerCertificateNumber: null, // 监理项目经理安全生产考核合格证书编号
        superManagementCertificateNumber: null, // 监理专职安全生产管理人员安全生产考核合格证书编号
        superManagementCertificateName: null, // 监理专职安全生产管理人员姓名
        superPlanTimeLimit: null, // 监理计划工期
        constructionState: null, // 施工单位确认状态
        constructionSealDate: null, // 施工单位盖章日期
        econState: null, // 勘察单位确认状态
        econSealDate: null, // 勘察单位盖章日期
        designState: null, // 设计单位确认状态
        designSealDate: null, // 设计单位盖章日期
        superState: null, // 监理单位确认状态
        superSealDate: null, // 监理单位盖章日期
        econProjectCost: null, // 勘察工程造价
        designProjectCost: null, // 设计工程造价
        superProjectCost: null // 监理工程造价
      },
      // 表单错误提示
      errRules: {
        disagreeReason: null // 不同意理由
      },
      // 全局加载
      fullLoading: null,
      // 主键
      id: this.$route.query.id,
      // 操作类型
      controllerFlg: this.$route.query.controllerFlg,
      /***********************************工程施工单位项目管理机构配备情况*************************************/
      // 加载
      organizationAllocationinfoLoading: false,
      // 表格基础数据
      organizationAllocationinfoTableColumns: [
        {
          label: "职务",
          prop: "duty"
        },
        {
          label: "姓名",
          prop: "name"
        },
        {
          label: "职称",
          prop: "positionalTitles"
        },
        {
          label: "证书名称",
          prop: "certificateName"
        },
        {
          label: "级别",
          prop: "level"
        },
        {
          label: "证号",
          prop: "number"
        },
        {
          label: "专业",
          prop: "professional"
        }
      ],
      // 列表数据
      organizationAllocationinfoTableData: [],
      // 分页
      organizationAllocationinfoReqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 分页总条数
      organizationAllocationinfoTotal: 0,
      /***************************************联合体单位*******************************************/
      unionLoading: false, // 列表loading状态
      // 联合体单位表单
      unionForm: {},
      // 表格基础数据
      unionTableColumns: [
        {
          label: "联合体单位名称",
          prop: "unionCorpName"
        },
        {
          label: "联合体单位类型",
          prop: "unionUnitTypeName"
        },
        {
          label: "是否同意",
          slotName: "isAgree"
        },
        {
          label: "确认日期",
          prop: "sealDate"
        }
      ],
      // 表格数据
      unionTableData: []
    };
  },

  // 注册组件
  components: {
    RecordDirectlyLogs, // 直接发包备案日志
    AuditHistoryRecord, // 历史核验记录
    TenderPictureinfor // 附件页面
  },
  // 模板编译完成
  mounted() {
    // 默认获取第一个流程表单
    this.formConfigList = this.stepsList[this.stepsActive].formList;
    // 获取详情
    this.fun_GetDetail();
  },
  // 自定义方法
  methods: {
    /**
     * 获取详情
     */
    fun_GetDetail() {
      // 发起请求
      fun_PostAction("/contractRecordUnion/detail", {
        id: this.id
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 表格数据
          this.form = data;
          // 房屋建筑工程建筑面积不为空
          if (data.constructionArea || data.constructionArea == 0) {
            // 设置
            this.form.constructionArea = data.constructionArea.toString();
          }
          // 工程造价不为空
          if (data.projectCost) {
            // 设置
            this.form.projectCost = data.projectCost.toString();
          }
          // 勘察工程造价不为空
          if (data.econProjectCost) {
            // 设置
            this.form.econProjectCost = data.econProjectCost.toString();
          }
          // 设计工程造价不为空
          if (data.designProjectCost) {
            // 设置
            this.form.designProjectCost = data.designProjectCost.toString();
          }
          // 监理工程造价不为空
          if (data.superProjectCost) {
            // 设置
            this.form.superProjectCost = data.superProjectCost.toString();
          }
          // 执行处理页面显示方法
          this.fun_GetHandle();
          // 设置备案项目内容下拉框
          this.fun_SelectTenderContentNum();
          // 获取一览表格数据
          this.fun_GetOrganizationAllocationList();
          // 联合体单位信息
          this.fun_ContractRecordUnionList();
        } else {
          // 提示请求失败的信息
          this.$message.error(msg);
        }
      });
    },
    /**
     * 联合体单位集合
     */
    fun_ContractRecordUnionList() {
      // 直接发包备案主键不为空
      if (this.form.contractRecordDirectlyId) {
        // 打开loading
        this.unionLoading = true;
        // 发起请求
        fun_PostAction("/contractRecordDirectly/unionList", {
          recordDirectlyId: this.form.contractRecordDirectlyId
        }).then(res => {
          // 解构res.data
          const { result, data } = res.data;
          // 操作成功
          if (result) {
            // 联合体列表数据
            this.unionTableData = data;
          }
          // 关闭加载
          this.unionLoading = false;
        });
      }
    },
    /**
     * 页面显示
     */
    fun_GetHandle() {
      // 备案状态是1解除合同或者2申请解除中,
      if (this.form.recordState == "1" || this.form.recordState == "2") {
        // 是否存在
        let rtn = false;
        // 遍历查询表单
        this.stepsList[0].formList.map((item, num) => {
          // 如果是解除合同文件扫描件
          if (item.title === "解除合同文件扫描件") {
            // 设置为存在
            rtn = true;
          }
        });
        // 如果不存在
        if (!rtn) {
          // 删除
          this.stepsList[0].formList.splice(0, 0, {
            title: "解除合同文件扫描件",
            name: "2",
            icon: "",
            formConfigList: [
              {
                label: "解除合同文件扫描件：",
                value: "uploadFile",
                type: "slot",
                slotName: "uploadFile",
                width: "100%"
              }
            ]
          });
        }
      }
      // 遍历流程
      this.stepsList.map(e => {
        (e.isSave = true), // 默认保存
          (e.isActive = true); // 默认可点击
        // 遍历标签页
        e.formList.map(formList => {
          // 遍历标签页内表单
          formList.formConfigList.map(form => {
            // 如果不是不同意意见
            if (form.value != "disagreeReason") {
              // 置灰
              form.disabled = true;
            }
          });
        });
      });
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
      // 备案项目类别
      if (i === "tenderClassNum") {
        // 设置备案项目内容下拉框
        this.fun_SelectTenderContentNum();
      }
    },
    /**
     * 设置备案项目内容下拉框
     */
    fun_SelectTenderContentNum() {
      // 备案项目类别不为空
      if (this.form.tenderClassNum) {
        // 遍历流程
        this.stepsList.map(item => {
          // 遍历流程表单
          item.formList.map(formList => {
            // 遍历表单内容
            formList.formConfigList.map(formConfigList => {
              // 如果是备案项目内容
              if (formConfigList.value === "tenderContentNum") {
                // 修改下拉框请求参数，重新赋值
                formConfigList.queryParams = {
                  url: "/dataDictionaryEntries/recordCombobox",
                  tenderClassNum: this.form.tenderClassNum
                };
              }
            });
          });
        });
      }
    },
    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading() {
      this.fullLoading = Loading.service({
        lock: true,
        text: "正在进行操作，请耐心等待...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
    /**
     * 监听滚动
     */
    fun_HandleScroll(e) {
      // 判断
      if (e.target.offsetTop < this.$refs.sticky.offsetTop) {
        // 添加样式
        this.$refs.sticky.style.boxShadow = "0 0 8px 3px rgba(0, 0, 0, 0.06)";
      } else {
        // 添加样式
        this.$refs.sticky.style.boxShadow = "none";
      }
    },
    /**
     * 点击流程
     */
    fun_GetClickSteps(val, index) {
      // 判断是否可点击
      if (val.isActive) {
        // 赋值下标
        this.stepsActive = index;
        // 获取表单数据
        this.formConfigList = val.formList;
      }
    },
    /**
     * 上一步
     */
    fun_GetLastStep() {
      // 减1
      this.stepsActive--;
      // 获取表单数据
      this.formConfigList = this.stepsList[this.stepsActive].formList;
    },
    /**
     * 下一步
     */
    fun_GetNextStep() {
      // 加1
      this.stepsActive++;
      // 设置下一个流程可点击
      this.stepsList[this.stepsActive].isActive = true;
      // 获取表单数据
      this.formConfigList = this.stepsList[this.stepsActive].formList;
    },
    /**
     * 确定的方法
     * @author shuhua
     */
    fun_Submit(e) {
      // 弹出询问confirm
      this.$confirm("是否同意联合体！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 执行保存
        this.fun_SaveOrUpdate(e);
      });
    },
    /**
     * 保存或修改的方法
     * @author shuhua
     */
    fun_SaveOrUpdate(e) {
      // 打开遮罩
      this.fun_Loading();
      // 发起请求
      fun_PostAction("contractRecordUnion/saveOrUpdate", {
        ...this.form,
        isAgree: e
      }).then(res => {
        // 解构res.data
        const { result, msg, data } = res.data;
        // 加载框取消
        this.fullLoading.close();
        // 操作成功
        if (result) {
          // 操作成功
          this.$message.success(msg);
          // 返回一览
          this.fun_Back();
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
      });
    },
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetOrganizationAllocationList() {
      // 打开loading
      this.organizationAllocationinfoLoading = true;
      // 发起请求
      fun_PostAction("/organizationAllocation/list", {
        ...this.organizationAllocationinfoReqPageData,
        contractRecordDirectlyId: this.form.contractRecordDirectlyId
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.organizationAllocationinfoTableData = records;
          // 获取分页总条数
          this.organizationAllocationinfoTotal = total;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.organizationAllocationinfoLoading = false;
      });
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.organizationAllocationinfoReqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetOrganizationAllocationList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.organizationAllocationinfoReqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetOrganizationAllocationList();
    },
    /**
     * 附件上传
     */
    fun_GetPictureinfor(e) {
      // 打开弹窗
      this.$refs.tenderPictureinfor.dialogVisible = true;
      // 打开弹窗
      this.$refs.tenderPictureinfor.type = e;
      // 打开弹框时调用
      this.$refs.tenderPictureinfor.fun_GetOpen();
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    }
  }
};
